import React from 'react';
import './eventTags.scss';
import timeIcon from '../assets/time.svg';
import moment from 'moment';

interface Props {
  eventTime: string;
}

const EventTags: React.FC<Props> = ({ eventTime }) => {
  return (
    <div className="eventTagsLayoutContainer">
      {eventTime.toString() >= new Date().toISOString() && (
        <div className="eventTagsContainer">
          <p>UPCOMING EVENT</p>
        </div>
      )}
      <div className="eventTagsContainer">
        <img src={timeIcon} alt="time icon" />
        <p>{`${moment(eventTime).format('MMM, DD, YYYY, h:mm A')}`}</p>
      </div>
    </div>
  );
};

export default EventTags;
